import { render, staticRenderFns } from "./LottoRatePerUser.vue?vue&type=template&id=80f76278&"
import script from "./LottoRatePerUser.vue?vue&type=script&lang=js&"
export * from "./LottoRatePerUser.vue?vue&type=script&lang=js&"
import style0 from "./LottoRatePerUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports